import { useState, useEffect } from 'react';
import { AsyncStorage } from 'react-native';


const IS_ENABLED_STORAGE_KEY = 'safari-reading-list-enabled';

const useIsReadingListEnabled = () => {
  const [isEnabled, setEnabledInternal] = useState(false);

  useEffect(() => {
    (async () => {
      const isEnabledStored = await AsyncStorage.getItem(IS_ENABLED_STORAGE_KEY);
      setEnabledInternal(isEnabledStored ? JSON.parse(isEnabledStored) : false);
    })();
  }, []);

  const setEnabled = async (newValue) => {
    setEnabledInternal(newValue);
    await AsyncStorage.setItem(IS_ENABLED_STORAGE_KEY, JSON.stringify(newValue));
  };

  const toggle = async () => {
    const newValue = !isEnabled;
    setEnabled(newValue);
  };

  return [isEnabled, toggle];
};

export default useIsReadingListEnabled;
